import {jsx} from 'panel';
import type {VNode} from 'snabbdom';
import type {JsxVNodeChildren} from 'snabbdom-jsx-lite';

import {layoutManager} from 'common/report/util/layout-manager';

export const MIN_PAGE_WIDTH = 1150; // px

// Note: CSS padding percent is based on the parent's width, which is .width-frame's width in this case
export const HORIZONTAL_CONTENT_PADDING_STYLE = `calc(min(96px, 5.5%))`;

export function ContentFrame(
  {
    sel,
    contentFrameClass,
    minContentWidth,
    maxContentWidth,
    isDownloadMode = false,
    includePadding = true,
    onPaddingFrameInsert = null,
    isReportScrollContainer = false,
  }: {
    sel?: string;
    contentFrameClass?: Record<string, boolean>;
    minContentWidth?: number;
    maxContentWidth?: number;
    isDownloadMode?: boolean;
    includePadding?: boolean;
    onPaddingFrameInsert?: (paddingFrame: VNode) => void;
    isReportScrollContainer?: boolean;
  },
  block: JsxVNodeChildren,
): VNode {
  // we don't want to apply any content width restrictions in Download Mode
  if (isDownloadMode) {
    return <div sel={sel}>{block}</div>;
  }

  function onReportScrollContainerInserted(vnode: VNode) {
    if (isReportScrollContainer) {
      layoutManager.setConfig({
        reportScrollContainer: vnode.elm as HTMLElement,
      });
    }
  }

  return (
    <div sel={sel} class={contentFrameClass} hook={{insert: onReportScrollContainerInserted}}>
      <div
        sel='.width-frame'
        style={{
          margin: includePadding ? `0 auto` : null,
          'max-width': maxContentWidth ? `${maxContentWidth}px` : undefined,
          'min-width': minContentWidth ? `${minContentWidth}px` : undefined,
        }}
      >
        <div
          sel='.padding-frame'
          style={{
            'box-sizing': `border-box`,
            padding: includePadding
              ? `0 ${HORIZONTAL_CONTENT_PADDING_STYLE} 6vh ${HORIZONTAL_CONTENT_PADDING_STYLE}`
              : null,
          }}
          hook={{
            insert: onPaddingFrameInsert,
          }}
        >
          {block}
        </div>
      </div>
    </div>
  );
}
